import log from 'salvo-lite/log'

class ChangeClassOnScroll {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._scrollChange = JSON.parse(elem.getAttribute('data-scroll-change') || '{}')
        this._changeElem = document.querySelector(this._scrollChange.elem) || this._elem
        this._scrollVal = parseInt(this._scrollChange.scroll_val) || 0
        this._scrollClass = this._scrollChange.class || ''

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const {
            changeClass,
            _changeElem,
            _scrollVal,
            _scrollClass
        } = this

        window.addEventListener('scroll', event => {
            if (document.querySelector('.search-box').classList.contains('active')) {
                return
            }

            changeClass(
                event.target.scrollingElement.scrollTop,
                _changeElem,
                _scrollVal,
                _scrollClass
            )
        })

        changeClass(window.scrollY, _changeElem, _scrollVal, _scrollClass)
    }

    changeClass (scrollVal, _elem, _val, _class) {
        if (scrollVal < _val) {
            _elem.classList.add(_class)
        } else {
            _elem.classList.remove(_class)
        }
    }
}

export default ChangeClassOnScroll



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ChangeClassOnScroll.js